import { z } from "zod";
import { SectionTypeEnum } from "./probation-form.schema.ts";

export const QuestionTypeEnum = z.enum(["TEXT", "RATING", "RADIO", "CHECKBOX"]);
export type QuestionType = z.infer<typeof QuestionTypeEnum>;

export const ProbationQuestionRequestSchema = z.object({
    cycleId: z.number(),
    sectionType: SectionTypeEnum
})

export type ProbationQuestionRequest = z.infer<typeof ProbationQuestionRequestSchema>;

export const ProbationQuestionSchema = z.object({
    reviewId: z.number(),
    questionId: z.number(),
    question: z.string(),
    questionType: QuestionTypeEnum,
    optionsJson: z.string().nullish(),
    sequenceNo: z.number(),
    answer: z.string().nullish(),
    textAnswers: z.string().nullish(),
    status: z.string(),
    editable: z.boolean()
})

export type ProbationQuestion = z.infer<typeof ProbationQuestionSchema>;
